import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { computeSeoTags } from '@/lib/seo';
import { applySeoTags } from '@/components/seo/Seo';

/**
 * Central indexing policy. Runs on every client-side route transition and
 * resets the full metadata set to the route default before the page's own
 * <Seo> (if any) refines it. This guarantees a route without <Seo> becomes
 * noindex,follow even when it was reached from an indexable page.
 */
export const SeoRoutePolicy = () => {
  const location = useLocation();

  useEffect(() => {
    applySeoTags(computeSeoTags({ path: location.pathname }));
  }, [location.pathname]);

  return null;
};
